/**
 * Returns an object based on the keys and values included in a query string.
 *
 * @param {string} qs - The query string that needs to be parsed
 *
 * @example
 * const qs = '?x=abc&y=def';
 * const parsedQs = parseQueryStrings(qs);
 *
 * console.log(parsedQs); // { x: 'abc', y: 'def' }
 */

export type ObjectQueryParams =
  | {
      [key: string]: string | boolean;
    }
  | undefined;

const parseQueryStrings = (qs?: string): ObjectQueryParams => {
  if (!qs) {
    return;
  }
  const queryStrings = qs.replace('?', '').split('&');
  const parsedObject: {
    [key: string]: string | boolean;
  } = {};

  queryStrings.forEach(q => {
    const keyAndValue = q.split('=');

    /**
     * If we don't validate the keyAndValue[0] (key), we will get a { '': true } when qs is equal to "?&"
     */
    if (keyAndValue[0]) {
      parsedObject[keyAndValue[0]] = keyAndValue[1] || true;
    }
  });

  return parsedObject;
};

export default parseQueryStrings;
